module.exports = __webpack_public_path__ + "media/images/lp_v6_check12-9098b510a74128c08e3edbf0da5774ea.svg";